/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import RichText from 'apmui/components/markup/RichTextView';
import ITemplateModel from './Model';

class PageFooter extends React.Component<ITemplateModel['general']> {
    render() {
        return (
            <footer className="apmui-footer">
                <div className="apmui-footer--content" id="copyright">
                    <RichText text={this.props.footer.message} />
                </div>
            </footer>
        );
    }
}

export default PageFooter;
